module.exports = ".pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/dateTimePicker/dateTimePicker.component.scss
// module id = ./src/app/components/common/dateTimePicker/dateTimePicker.component.scss
// module chunks = main